module.exports = {"id":"184941","name":"Alexis Sánchez","rating":"88","photo":"./data/images/photos/2/184941.png","club":{"name":"Manchester Utd","logo":"./data/images/clubs/ManchesterUtd.png"},"positions":["AG","BU","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexisSanchez0.json
// module id = 273
// module chunks = 0